const HEADER_FILL_ARGB = "FF1F4E78";
const HEADER_TEXT_ARGB = "FFFFFFFF";
const HEADER_FONT_NAME = "Carlito";

export function styleHeaderRow(headerRow) {
	if (!headerRow) return;
	headerRow.eachCell({ includeEmpty: false }, (cell) => {
		cell.fill = {
			type: "pattern",
			pattern: "solid",
			fgColor: { argb: HEADER_FILL_ARGB },
		};
		cell.font = {
			name: HEADER_FONT_NAME,
			bold: true,
			color: { argb: HEADER_TEXT_ARGB },
			size: 11,
		};
		cell.alignment = { vertical: "top", horizontal: "left", wrapText: true };
	});
}

function longestLineLength(value) {
	if (value === null || value === undefined) return 0;
	let str;
	if (value instanceof Date) {
		str = value.toLocaleDateString();
	} else if (typeof value === "object") {
		if (typeof value.text === "string") str = value.text;
		else if (typeof value.richText === "object" && Array.isArray(value.richText)) {
			str = value.richText.map((r) => r.text || "").join("");
		} else if (typeof value.result !== "undefined") {
			str = String(value.result);
		} else {
			str = String(value);
		}
	} else {
		str = String(value);
	}
	let max = 0;
	for (const line of str.split("\n")) {
		if (line.length > max) max = line.length;
	}
	return max;
}

function estimateWrappedLines(value, columnWidth) {
	if (value === null || value === undefined) return 0;
	const text = String(value);
	const lineCap = Math.max(columnWidth - 1, 1);
	let lines = 0;
	for (const segment of text.split("\n")) {
		lines += Math.max(1, Math.ceil(segment.length / lineCap));
	}
	return lines;
}

export function autoFitColumns(sheet, options = {}) {
	const { headerRowNumber, minWidth = 10, maxWidth = 95, padding = 2, lineHeight = 15, maxHeight = 195 } = options;
	if (!sheet || !sheet.columns) return;
	sheet.columns.forEach((column) => {
		let longest = minWidth;
		column.eachCell({ includeEmpty: false }, (cell, rowNumber) => {
			if (rowNumber === headerRowNumber) return;
			const len = longestLineLength(cell.value);
			if (len > longest) longest = len;
		});
		const width = Math.min(Math.max(longest + padding, minWidth), maxWidth);
		column.width = width;
	});

	const colCount = sheet.columnCount;

	if (headerRowNumber) {
		const headerRow = sheet.getRow(headerRowNumber);
		let maxLines = 1;
		for (let c = 1; c <= colCount; c++) {
			const cell = headerRow.getCell(c);
			if (cell.value === null || cell.value === undefined) continue;
			const colWidth = sheet.getColumn(c).width || minWidth;
			const lines = estimateWrappedLines(cell.value, colWidth);
			if (lines > maxLines) maxLines = lines;
		}
		if (maxLines > 1) {
			headerRow.height = Math.min(maxLines * lineHeight + 4, maxHeight);
		}
	}

	const lastRow = sheet.rowCount;
	const headerNum = headerRowNumber || 0;
	for (let r = headerNum + 1; r <= lastRow; r++) {
		const row = sheet.getRow(r);
		let maxLines = 1;
		for (let c = 1; c <= colCount; c++) {
			const cell = row.getCell(c);
			cell.alignment = { vertical: "top", horizontal: "left", wrapText: true };
			if (cell.value === null || cell.value === undefined) continue;
			const colWidth = sheet.getColumn(c).width || minWidth;
			const lines = estimateWrappedLines(cell.value, colWidth);
			if (lines > maxLines) maxLines = lines;
		}
		const naturalHeight = maxLines * lineHeight + 4;
		if (naturalHeight > maxHeight) {
			row.height = maxHeight;
		}
	}
}
